// import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import { Navbar } from './components/Navbar';
import { Shop } from './pages/shop/Shop';
import { Cart } from './pages/cart/Cart';
import { ProductDetails } from './pages/ProductDetails/ProductDetails';
// import { PaymentForm } from './pages/checkout/PaymentForm';

import { ShopContextProvider } from './context/Shop-context';

import { Footer } from './components/Footer';
// import {ProductDetails} from './pages/checkout/ProductDetails_temp';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';


function App() {
  
  return (
    <div className="App">
      <ShopContextProvider>
        <Router>
          <Navbar/>
          <Routes>

            <Route path='/' element={<Shop />} >
            {/* <Shop/> */}
            </Route>

            <Route path='/cart' element={<Cart />}>
            </Route>

            <Route path='/Login'>
            </Route>

            {/* <Route path='/checkOut' element={<Checkout/>}> */}
            {/* <Route path='/checkOut' element={<PaymentForm/>}>
            </Route> */}

            <Route path='/ProductDetails/:id' element={<ProductDetails/>}>
            </Route>

          </Routes>
        </Router>
        <br></br>
        <Footer/>
      </ShopContextProvider>
    </div>
  );
}

export default App;
